import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../assets/img/icons/left-arrow.svg'
import _imports_1 from '../../../assets/img/icons/right-arrow.svg'


const _hoisted_1 = { class: "container pt-60 pb-100" }
const _hoisted_2 = { class: "offer-wrapper" }
const _hoisted_3 = { class: "offer-img" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "offer-content" }
const _hoisted_6 = { class: "fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_swiper, {
        spaceBetween: 24,
        grabCursor: true,
        loop: false,
        navigation: {
          nextEl: '.offer-next',
          prevEl: '.offer-prev',
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          992: {
            slidesPerView: 2,
          },
          1200: {
            slidesPerView: 3,
          },
          1400: {
            slidesPerView: 3,
          },
        },
        modules: _ctx.modules,
        class: "offer-slider"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offers, (offer) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              key: offer.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(['offer-card', offer.class])
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("img", {
                      src: offer.image,
                      alt: "Image"
                    }, null, 8, _hoisted_4)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h6", null, [
                      _createVNode(_component_router_link, { to: "/shop-right-sidebar" }, {
                        default: _withCtx(() => [
                          _cache[0] || (_cache[0] = _createTextVNode(" Get ", -1)),
                          _createElementVNode("span", _hoisted_6, _toDisplayString(offer.percent) + "%", 1),
                          _createTextVNode(" " + _toDisplayString(offer.desc), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createVNode(_component_router_link, {
                      to: "/shop-left-sidebar",
                      class: "btn style-two"
                    }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode(" Available Offer ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ], 2)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modules"]),
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"slider-btn\" data-v-46105ba4><div class=\"offer-prev\" data-v-46105ba4><img src=\"" + _imports_0 + "\" alt=\"Image\" data-v-46105ba4></div><div class=\"offer-next\" data-v-46105ba4><img src=\"" + _imports_1 + "\" alt=\"Image\" data-v-46105ba4></div></div>", 1))
    ])
  ]))
}